import { RetentionReport } from "./reducer";

export const TransformReportResponse = (
  response: RetentionResponse
): RetentionReport => {
  let rows = response.rows;

  rows.sort((a, b) => {
    return b.date > a.date ? -1 : 1;
  });

  return {
    from: response.from,
    until: response.until,
    rows: response.rows,
  };
};

export interface RetentionResponseRow {
  date: string;
  installs: number;
  spend: number;
  revenueD1: number;
  revenueD3: number;
  revenueD7: number;
  revenueD14: number;
  revenueD30: number;
  revenueD60: number;
  revenueD90: number;
  revenueD120: number;
  revenueD150: number;
  revenueD180: number;

  roasD0: number;
  roasD1: number;
  roasD3: number;
  roasD7: number;
  roasD14: number;
  roasD30: number;
  roasD60: number;
  roasD90: number;
  roasD120: number;
  roasD150: number;
  roasD180: number;
}

export interface RetentionResponse {
  from: Date;
  until: Date;
  rows: RetentionResponseRow[];
}
